module.exports = __webpack_public_path__ + "img/logo.e2cd6233.png";